import '../style/cell-list-DKwcRRMH.css'
import { defineComponent as b, openBlock as s, createBlock as m, unref as i, normalizeProps as A, mergeProps as B, withCtx as D, createTextVNode as u, toDisplayString as r, createElementBlock as a, Fragment as p, createCommentVNode as O, toRefs as H, computed as c, normalizeClass as y, normalizeStyle as R, renderList as U, createElementVNode as S, renderSlot as h, createVNode as Z } from "vue";
import { isNil as j } from "lodash-es";
import q from "./divider.js";
import x from "./skeleton.js";
import { DEFAULT_SIZE as G } from "./constant/common.js";
import { useComponentClassList as J } from "./hooks/useComponentClassList.js";
import { getSpaceClass as K, SpaceTypeEnum as Q, getSpacingVariableBySize as W, getSpaceValue as X } from "./utils/style.js";
import Y from "./tooltip.js";
const w = {
  key: 0,
  class: "e-cell-item__helper-text"
}, I = /* @__PURE__ */ b({
  __name: "cell-label",
  props: {
    row: {}
  },
  setup(_) {
    return (t, f) => t.row.labelTooltip ? (s(), m(i(Y), A(B({ key: 0 }, t.row.labelTooltip)), {
      default: D(() => [
        u(r(t.row.label), 1)
      ]),
      _: 1
    }, 16)) : (s(), a(p, { key: 1 }, [
      u(r(t.row.label) + " ", 1),
      t.row.helperText ? (s(), a("div", w, r(t.row.helperText), 1)) : O("", !0)
    ], 64));
  }
}), ee = { class: "e-cell-item__label" }, te = { class: "e-cell-item__value" }, C = "e-cell-list", ce = /* @__PURE__ */ b({
  name: C,
  __name: "cell-list",
  props: {
    data: { default: () => [] },
    isBordered: { type: Boolean, default: !0 },
    size: { default: G },
    dividerSpace: { default: 0 },
    loading: { type: Boolean },
    skeleton: {},
    cellPadding: {},
    itemLayout: {},
    cellItemIndention: {}
  },
  setup(_) {
    const t = _, { size: f, isBordered: L, itemLayout: N } = H(t), T = {
      sm: "6px",
      md: "8px",
      lg: "10px"
    }, $ = c(() => ({
      height: T[f.value || "md"],
      ...t.skeleton
    })), v = c(() => {
      let l = !1, n = !1, e = 0;
      const o = t.data;
      return o.map((F, M) => {
        const { type: g, indented: d, ...k } = F;
        return d ? (e++, l = e === 1, o[M + 1]?.indented || (n = !0)) : (l = !1, n = !1, e = 0), d ? {
          ...k,
          indented: d,
          isFirstIndented: l,
          isLastIndented: n,
          type: g || "item"
        } : {
          ...k,
          indented: d,
          type: g || "item"
        };
      });
    }), z = K(Q.Margin, t.dividerSpace), E = J(C, {
      isBordered: L,
      size: f,
      layout: N
    }), P = c(() => v.value.some((l) => l.indented)), V = c(() => {
      const l = W(t.size), n = {
        "--cell-item-padding": j(t.cellPadding) ? l : X(t.cellPadding, l)
      };
      return P.value && (n["--cell-item-indention"] = (t.cellItemIndention || 24) + "px"), n;
    });
    return (l, n) => (s(), a("div", {
      class: y(i(E)),
      style: R(V.value)
    }, [
      (s(!0), a(p, null, U(v.value, (e, o) => (s(), a(p, { key: o }, [
        e.type === "divider" ? (s(), m(i(q), {
          key: 0,
          class: y(i(z))
        }, null, 8, ["class"])) : (s(), a("div", {
          key: 1,
          class: y(["e-cell-item", { "e-cell-item--indented": e.indented, "is-first": e.isFirstIndented, "is-last": e.isLastIndented }])
        }, [
          S("div", ee, [
            e.labelSlot ? h(l.$slots, e.labelSlot, {
              key: 0,
              row: e,
              index: o
            }, () => [
              Z(I, { row: e }, null, 8, ["row"])
            ]) : (s(), m(I, {
              key: 1,
              row: e
            }, null, 8, ["row"]))
          ]),
          S("div", te, [
            l.loading ? (s(), m(i(x), B({
              key: 0,
              ref_for: !0
            }, $.value), null, 16)) : e.valueSlot && l.$slots[e.valueSlot] ? h(l.$slots, e.valueSlot, {
              key: 1,
              row: e,
              index: o
            }, () => [
              u(r(e.valueSlot), 1)
            ]) : (s(), a(p, { key: 2 }, [
              u(r(e.value), 1)
            ], 64))
          ])
        ], 2))
      ], 64))), 128))
    ], 6));
  }
});
export {
  ce as default
};
//# sourceMappingURL=cell-list.js.map
